module.exports = __webpack_public_path__ + "img/star.444e89f2.svg";